import React from 'react';
import { connect } from 'react-redux';

import store from '../../../store/createStore';
import Config from '../../../core/config';

import InfoIcon from '../../CvvTooltip';
import InputField from '../../shared/form/InputField';
import {createScriptURL} from '../../../trusted-security-policies';

import fieldValidate from '../validation'
import {getIssuerByCardNumber} from '../utils'
import {pushPaymentSubmitErrorAction} from '../../../helpers/gtm';

let pspSessGlobal = ''
let formDataGlobal = null
const cardinalConfigs = {
  timeout: 100000,
  extendedtimeout: 50000,
  maxRequestRetries: 1,
  button: {
    containerId: 'Cardinal-Payments',
  },
  logging: {
    level: 'on',
  },
  payment: {
    view: 'modal',
    framework: 'cardinal',
    displayLoading: true,
  },
  applePay: {
    button: {
      containerId: 'MySpecificApplePayId',
      color: 'black',
    },
  },
  paypal: {
    button: {
      containerId: 'MySpecificPayPalId',
      color: 'gold',
      shape: 'rect',
      style: 'paypal',
      size: '44px',
    },
    flow: 'checkout',
    intent: 'order',
    offerCredit: false,
    enableShippingAddress: false,
    shippingAddressEditable: true,
  },
  visaCheckout: {
    button: {
      containerId: 'MySpecificVisaCheckoutId',
      color: '',
      size: '',
      height: '',
      width: '',
      locale: '',
    },
  },
};


class CardForm extends React.Component {
  constructor() {
    super();
    this.state = {
      number: '',
      name: '',
      expiry: '',
      cvc: '',
      issuer: '',
      requireFields: [],
      validFields: [],
      formTouched: false,
    };
  }

  componentDidMount() {
    if(formDataGlobal){
      this.setState(formDataGlobal)
    }

    const { userData, metrixSrc, transInfo, sendPayment, data } = this.props
    const { number } = this.state
    const { Cardinal } = window
    const metrixSrcScript = document.createElement('script')

    if (data?.prefilledData) {
      this.setPrefilledData(data.prefilledData)
    }

    metrixSrcScript.src = createScriptURL(metrixSrc);
    metrixSrcScript.async = true;

    if (metrixSrc && pspSessGlobal === '') {

      document.body.appendChild(metrixSrcScript);

      metrixSrcScript.onload = () => {
        Cardinal.configure(cardinalConfigs);
      };
    }

    if (userData && number !== userData.number) {
      this.setState(userData);
    }

    if (transInfo.length && pspSessGlobal === '') {
      Cardinal.setup('init', {
        jwt: transInfo,
      });
    }

    if (transInfo.length && pspSessGlobal === '') {
      Cardinal.on('payments.setupComplete', (setupCompleteData) => {
        pspSessGlobal = setupCompleteData.sessionId
      });

      Cardinal.on('payments.validated', (decodedResponseData, responseJWT) => {
        const errorNumber =
          decodedResponseData.ErrorNumber !== undefined ? decodedResponseData.ErrorNumber : 0;
        const errorDescription =
          decodedResponseData.ErrorDescription !== undefined
            ? decodedResponseData.ErrorDescription
            : 'empty';

        formDataGlobal.paymentStatusFailure = `ERROR_CARDINAL_JS_NO_decodedResponseData`;
        switch (decodedResponseData.ActionCode) {
          case 'SUCCESS':
            // formData.pspTransaction = responseJWT;
            formDataGlobal.pspTransaction = responseJWT;
            break;
          case 'NOACTION':
            // Handle no actionable outcome
            formDataGlobal.paymentStatusFailure = `ERROR_CARDINAL_JS_NOACTION_${errorNumber}_${errorDescription}`;
            break;
          case 'FAILURE':
            // Handle 'FAILURE' payment
            formDataGlobal.paymentStatusFailure = `ERROR_CARDINAL_JS_FAILURE_${errorNumber}_${errorDescription}`;
            break;
          case 'ERROR':
            // Handle service level error
            formDataGlobal.paymentStatusFailure = `ERROR_CARDINAL_JS_ERROR_${errorNumber}_${errorDescription}`;
            break;
          default:
            if (errorNumber === 0 && errorDescription === 'Success') {
              formDataGlobal.pspTransaction = responseJWT;
            } else {
              formDataGlobal.paymentStatusFailure = `CARDINAL_JS_DEFAULT_${errorNumber}_${errorDescription}`;
            }
            break;
        }
        sendPayment(formDataGlobal);
      });
    }
  }

  setPrefilledData = (data) => {
    this.setState({
      name: data.NameOfHolder || '',
    })
  }

  handleInputChange = async ({ name, value }) => {
    await this.setState({[name]: value})
    this.handleValidation();
  };

  updateIssuerValue = (cardNumber) => {
    const { issuer } = this.state;
    if (!cardNumber) {
      this.setState({issuer: ''})
      return;
    }

    const potentialIssuers = getIssuerByCardNumber(cardNumber);
    if (!potentialIssuers?.length)
      return;

    const newIssuer = Array.isArray(potentialIssuers) ? potentialIssuers[0] : potentialIssuers
    this.setState({issuer: newIssuer})
  }

  handleCardNumberChange = ({ value, name }) => {
    this.updateIssuerValue(value)
    this.handleInputChange({value, name})
  }

  handleBlur = ({ target }) => {
    const { data: {id} } = this.props;

    if (id === 'dinersClub') {
      this.setState({ issuer: 'DC' });
    }

    if (!target.readOnly) {
      this.handleValidation();
    }
  };

  pushValidationErrorsInfo = (errors) => {
    const {state} = this;
    const labels = {
      number: 'card number',
      name: 'name',
      expiry: 'expiration date',
      cvc: 'cvc'
    }

    const emptyFields = errors.filter(key => !state[key] && key in labels).map(key => labels[key])
    const invalidFields = errors.filter(key => state[key] && key in labels).map(key => labels[key])

    if (emptyFields.length) {
      pushPaymentSubmitErrorAction({
        error_field: emptyFields,
        error_type: 'empty cell'
      })
    }

    if (invalidFields.length) {
      pushPaymentSubmitErrorAction({
        error_field: invalidFields,
        error_type: 'incorrect value'
      })
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let response
    const { requireFields } = this.state
    const { sendPayment, transInfo } = this.props
    const { Cardinal } = window
    this.setState({formTouched: true})
    const errors = this.handleValidation()

    if (errors) {
      this.pushValidationErrorsInfo(errors)
    }

    if (window.dataLayer) {
      const { basketConditionsAgreement } = Config.gtm;

      window.dataLayer.push(basketConditionsAgreement);
    }

    if (!requireFields.length && !this.handleValidation().length) {
      const formData = [...e.target.elements]
        .filter((d) => d.name)
        .reduce((acc, d) => {
          acc[d.name] = d.value;
          return acc;
        }, {});

      formData.pspSess = pspSessGlobal
      formDataGlobal = formData

      window.pspSessGlobal = pspSessGlobal

      const formatCardNumber = formData.number.replace(/\s/g, '');
      // eslint-disable-next-line no-inner-declarations
      async function initBin() {
        // need to make sure we got response from Drupal > Accor
       await sendPayment(formData)
       response = store.getState().payment.sendPaymentResponse;
        const isDuplicated = response?.attentionPopIn?.isDuplicated;
        if (!isDuplicated && transInfo.length) {
          Cardinal.trigger('bin.process', formatCardNumber)
            .then(function (results) {
              if (results.Status) {
                if (response.pspTransactionId) {
                  Cardinal.continue(
                    'cca',
                    {
                      AcsUrl: response.url,
                      Payload: response.payload,
                    },
                    {
                      OrderDetails: {
                        TransactionId: response.pspTransactionId,
                      },
                    },
                  );
                }
              } else {
                alert('Bin profiling failed');
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          // sendPayment(formData)
        }
      }
      initBin()
    }
  };

  handleValidation = (newDate, target) => {
    const { state } = this;
    const data = newDate || state;
    const { data: {paymentMethods, id} } = this.props;
    const requireFields = [];
    const validFields = [];

    const toggleIncorrect = function (item) {
      if (requireFields.indexOf(item) < 0) {
        requireFields.push(item);
      }
    }

    const toggleCorrect = function (item) {
      if (validFields.indexOf(item) < 0) {
        validFields.push(item);
      }
    }

    const newState = Object.keys(data).reduce((acc, item) => {
      const value = data[item];
      let validateRules;
      let month;
      let year;
      let currentYear;
      switch (item) {
        case 'name':
          if (fieldValidate(['required', 'cardOwnerName'], value)) {
            toggleCorrect(item)
          } else {
            toggleIncorrect(item)
          }
          break;
        case 'number':
          validateRules = [...(paymentMethods?.[state.issuer]?.cardNumber?.validate || [])];
          if (state.issuer) {
            validateRules.push(`cardType-${state.issuer}`)
          }

          if (validateRules.length && fieldValidate(validateRules, value)) {
            toggleCorrect(item)
          } else {
            toggleIncorrect(item);
          }
          break;
        case 'expiry':
          month = parseInt(value.substr(0, 2), 10);
          year = parseInt(value.substr(3, 2), 10);
          currentYear = parseInt(
            new Date()
              .getFullYear()
              .toString()
              .substr(2, 2),
            10,
          );

          if (
            (!target || value.length === 5) &&
            (!value.length ||
              value.length < 5 ||
              month > 12 ||
              year < currentYear ||
              Date.now() > Date.parse(`20${year}/${month}/1`))
          ) {
            toggleIncorrect(item);
          } else {
            toggleCorrect(item)
          }
          break;
        case 'cvc':
          validateRules = paymentMethods?.[state.issuer]?.cardCVV?.validate || [];
          if (validateRules.length && fieldValidate(validateRules, value)) {
            toggleCorrect(item)
          } else {
            toggleIncorrect(item)
          }
          break;
        case 'issuer':
          if (!state.issuer.length && !data[item].length) {
            toggleIncorrect(item);
          } else {
            toggleCorrect(item)
          }
          break;
        case 'requireFields':
          if (JSON.stringify(requireFields) !== JSON.stringify(data[item])) {
            acc[item] = requireFields;
          }
          break;
        default:
          return acc;
      }

      if (JSON.stringify(requireFields) !== JSON.stringify(state.requireFields)) {
        acc.requireFields = requireFields;
        acc.validFields = validFields;
      }

      return acc;
    }, {});

    this.setState(newState);
    return requireFields;
  };

  getPaymentsList = function () {
    const {
      data: {
        bankCards: {
          card: {
            paymentAXTypes
          }
        },
        paymentMethods,
      },
    } = this.props;

    return Object.values(paymentMethods)
      .filter(el => !!el?.value?.length)
      .map(el => {
        const item = paymentAXTypes?.find(a => a.title === el?.label)
        return {
          logoSrc: item?.logoSrc,
          ...el,
        }
      }).sort((a, b) => a.rank - b.rank)
  }

  getImageByIssuer = function (issuer) {
    const payments = this.getPaymentsList();
    const activePayementData = payments.find(el => el.value === issuer);
    return activePayementData?.logoSrc
  }

  render() {
    const { name, number, expiry, cvc, issuer, requireFields, validFields, formTouched } = this.state;
    const {
      data: {
        id,
        placeholders,
        labels,
        learnMoreInfo,
        paymentMethods,
        formErrors,
      },
      formId,
    } = this.props;
    const cardNumberData = issuer ? paymentMethods[issuer]?.cardNumber : null;
    const cvvData = issuer ? paymentMethods[issuer]?.cardCVV : null;
    const issuerIcon = this.getImageByIssuer(issuer)

    return (
      <form
        key='payment-form'
        id={formId}
        className="payment-form"
        onSubmit={this.handleSubmit}
      >
        <input type="hidden" name="issuer" value={issuer}/>
        <div className="form-container">
          <div className="form-item form-item--full payment-card-icon">
            {issuerIcon && (<img className="payment-card-icon__issuer" src={issuerIcon} alt={issuer}/>)}
            <InputField
              state={this.state}
              inputName="number"
              inputType="tel"
              className={issuerIcon ? 'with-card-icon' : ''}
              placeholder={placeholders.cardNumber}
              label={labels.cardNumber}
              value={number}
              mask={cardNumberData?.mask || ''}
              validate={cardNumberData?.validate}
              changeHandler={this.handleCardNumberChange}
              blurHandler={this.handleBlur}
              paymentMethods={paymentMethods}
              required={formErrors.cardNumber}
              paymentName={id}
              formTouched={formTouched}
              isCsMask
            />
          </div>
          <div className="form-item">
            <InputField
              state={this.state}
              inputName="expiry"
              inputType="tel"
              placeholder={placeholders.expirationDate}
              label={labels.expirationDate}
              value={expiry}
              mask="00/00"
              validate={['required', 'futureDate']}
              changeHandler={this.handleInputChange}
              blurHandler={this.handleBlur}
              required={formErrors.cardExpiration}
              formTouched={formTouched}
              isCsMask
            />
          </div>
          <div className="form-item form-item--small tooltip__wrap">
            <InputField
              state={this.state}
              className="with-card-icon cvc-card-icon"
              inputName="cvc"
              inputType="tel"
              placeholder={placeholders.cvv}
              label={labels.cvv}
              mask={cvvData?.mask}
              value={cvc}
              validate={cvvData?.validate}
              changeHandler={this.handleInputChange}
              blurHandler={this.handleBlur}
              paymentMethods={paymentMethods}
              required={formErrors.cardCvv}
              formTouched={formTouched}
              isCsMask
            />
            <InfoIcon className="tooltip__button" tooltip={learnMoreInfo.label} cvvInfo={learnMoreInfo.cvvInfo}/>
          </div>
          <div className="form-item form-item--full" data-cs-mask="">
            <InputField
              state={this.state}
              inputName="name"
              inputType="text"
              placeholder={placeholders.NameOfHolder}
              label={labels.NameOfHolder}
              value={name}
              validate={['required']}
              required={name && formErrors.cardHolderAlphabet ? formErrors.cardHolderAlphabet : formErrors.cardHolder}
              changeHandler={this.handleInputChange}
              focusHandler={this.handleInputFocus}
              formTouched={formTouched}
            />
          </div>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    metrixSrc: state.payment.layoutStaticData.metrixSrc,
    transInfo: state.payment.layoutStaticData.transInfo,
    response: state.payment.sendPaymentResponse,
  };
}

export default connect(mapStateToProps)(CardForm);
